var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.indexModule.component,{tag:"component",attrs:{"foreingKey":_vm.indexModule.foreingKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }